import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { OneloginService } from '../../service';

export type MfaEnrollmentConfig = typeof MfaEnrollmentConfig._.Config;

export const MfaEnrollmentConfig = IntegrationConfig.make({
  service: OneloginService,
  name: Integration_Handler_Names_Enum.MfaEnrollment,
  configSchema: z.object({}),
});
